import { render, staticRenderFns } from "./Besturen.vue?vue&type=template&id=3cd44659&scoped=true&"
import script from "./Besturen.vue?vue&type=script&lang=js&"
export * from "./Besturen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd44659",
  null
  
)

export default component.exports